import { ReactElement } from 'react';
import { useDialog } from '@mews/framework';
import { DialogForm, DialogFormProps } from './DialogForm';

export type UseDialogFormProps = Omit<DialogFormProps, 'active'>;

export const useDialogForm = (props: Omit<DialogFormProps, 'active'>) => {
    const [toggleProps, toggleDialog] = useDialog();

    const renderDialog = () => (
        <DialogForm
            {...toggleProps}
            {...props}
            onClose={() => {
                toggleProps.onClose();
                props.onClose?.();
            }}
        />
    );

    return [renderDialog, toggleDialog] satisfies [() => ReactElement<DialogFormProps> | null, () => void];
};
